export const categories = [
  {
    slug: "entertainment",
    name: "娱乐",
    icon: "ri-movie-line",
    description: "搞笑段子、综艺精选、明星动态，放松心情的最佳选择",
    color: "from-rose-500 to-orange-500",
    count: 2840,
  },
  {
    slug: "lifestyle",
    name: "生活",
    icon: "ri-home-heart-line",
    description: "居家妙招、旅行日记、日常Vlog，记录美好生活每一刻",
    color: "from-amber-500 to-yellow-500",
    count: 1956,
  },
  {
    slug: "food",
    name: "美食",
    icon: "ri-restaurant-line",
    description: "烹饪教程、探店测评、美食文化，满足你的味蕾想象",
    color: "from-orange-500 to-red-500",
    count: 1623,
  },
  {
    slug: "tech",
    name: "科技",
    icon: "ri-smartphone-line",
    description: "数码评测、科技资讯、编程技巧，掌握前沿科技脉搏",
    color: "from-cyan-500 to-teal-500",
    count: 1340,
  },
  {
    slug: "gaming",
    name: "游戏",
    icon: "ri-gamepad-line",
    description: "游戏实况、电竞赛事、攻略解说，游戏玩家的聚集地",
    color: "from-violet-500 to-purple-500",
    count: 2156,
  },
  {
    slug: "music",
    name: "音乐",
    icon: "ri-music-line",
    description: "翻唱创作、乐器教学、音乐现场，用旋律连接你我",
    color: "from-pink-500 to-rose-500",
    count: 1876,
  },
  {
    slug: "sports",
    name: "运动",
    icon: "ri-basketball-line",
    description: "健身教程、赛事集锦、户外探险，点燃你的运动激情",
    color: "from-green-500 to-emerald-500",
    count: 1450,
  },
  {
    slug: "fashion",
    name: "时尚",
    icon: "ri-t-shirt-line",
    description: "穿搭分享、美妆教程、潮流趋势，做最闪亮的自己",
    color: "from-fuchsia-500 to-pink-500",
    count: 1230,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});